<template>
  <div v-if="booking.has_add_billing">
    <span
      v-if="booking.add_billing_paid"
      :data-tooltip="booking.additional_billing_invoice.payment_received | date('lll')"
      class="tooltip is-tooltip-bottom">
      <status-indicator status="positive" class="mr" />
      <small>Payment Received</small>
    </span>
    <span v-else>
      <status-indicator status="intermediary" class="mr" />
      <small>Pending Payment</small>
    </span>
  </div>
</template>

<script>
export default {

  props: {
    booking: Object
  }

}
</script>